import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import Address from 'AppComponents/Address';
import Distance from 'AppComponents/Distance';
import AverageRating from 'AppComponents/AverageRating';

import './styles.scss';


const Charger = ({ charger, selected, hovered, onMouseEnter, onMouseLeave }, { imperial }) => (
  <Link
    className={classNames(
      'list-group-item',
      'list-group-item-action',
      charger.is_supercharger ? 'supercharger' : 'destination-charger', {
        active: selected,
        hovered,
      },
    )}
    styleName='charger'
    to={`/charger/${charger.pk}/`}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
  >

    <h4>{ charger.title }</h4>

    <div styleName='content'>

      <Address address={charger.address} includeCountry={false} />

      { charger.distance_from_user ?
        <p>
          <FormattedMessage
            id='charger.distanceFromUser'
            values={{
              distance: <Distance value={charger.distance_from_user} imperial={imperial} />,
            }}
            defaultMessage='{distance} from your location'
          />
        </p>
      : null }

      { charger.average_rating ?
        <AverageRating rating={charger.average_rating} />
      : null }

    </div>

  </Link>
);

Charger.propTypes = {
  charger: PropTypes.shape({
    address: PropTypes.object,
    average_rating: PropTypes.number,
    distance_from_user: PropTypes.number,
    is_supercharger: PropTypes.bool,
    pk: PropTypes.number,
    title: PropTypes.string,
  }).isRequired,
  hovered: PropTypes.bool,
  onMouseEnter: PropTypes.func.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
  selected: PropTypes.bool,
};

Charger.defaultProps = {
  hovered: false,
  selected: false,
};

Charger.contextTypes = {
  imperial: PropTypes.bool.isRequired,
};

export default Charger;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/Home/components/ChargerList/components/Charger/index.jsx